<template>
	<v-navigation-drawer
		location="right"
		width="540"
		temporary
		:scrim="false"
		touchless
		disable-route-watcher
		:class="['drawer-container-right', myElevation, isCalendarItem]"
		v-model="openState"
		ref="rightDrawerContainer">

		<template v-if="contentComponent">
			<component :is="contentComponent" />
		</template>
		<template v-else>
			<!-- TODO: Has to be smooshed right after. Yeah, needed but can be loading swirly, etc? -->
			<div>Default Content</div>
		</template>

	</v-navigation-drawer>
</template>


<script>
	import { markRaw } from 'vue'
	import { mapState } from 'vuex'
	import { mapFields } from 'vuex-map-fields'

	export default {
		name: 'drawer-container-right',
		
		data:() => ({
			contentComponent: null,
			mouseIsOverDrawer: false,
		}),

		computed: {
			...mapState({
				mobileDrawerRightState: state => state.ui.mobileDrawerRight.openState
			}),

			...mapFields({ 
				content: 'ui.rightDrawer.content',
				isFixed: 'ui.rightDrawer.isFixed',
				overlayOpenState: 'ui.overlayMask.openState',
			}),

			openState: {
				get() { return this.$store.state.ui.rightDrawer.openState || this.mobileDrawerRightState },
				set(val) {
					if (!val && !this.mobileDrawerRightState) { 
						this.$store.dispatch('VUEX_UI_HIDE_RIGHT_DRAWER')
					}
				}
			},

			myElevation() {
				return this.isFixed ? 'elevation-0' : 'elevation-5'
			},

			isCalendarItem() {
                return this.content && this.content.file === 'Calendar_Item_Drawer' ? 'is-calendar-item-drawer' : ''
			},

			overlayElem() {
				return this.$root.$el.querySelector('.v-overlay')
			}
		},
		
		created() {
			this.loadContent()
		},

		mounted() {
			this.initEvents()
			document.addEventListener('keydown', this.handleEscapeKey)
			document.addEventListener('mousedown', this.handleOutsideClick)
		},

		beforeUnmount() {
			document.removeEventListener('keydown', this.handleEscapeKey)
			document.removeEventListener('mousedown', this.handleOutsideClick)
		},

		updated() {
			this.initEvents()
		},

		methods: {
			loadContent() {
			    const loaded = this.content ? this.$root.loadComponent(this.content) : null
			    this.contentComponent = loaded ? markRaw(loaded) : null
			},

			// Close the drawer on Escape — `v-navigation-drawer` ships its
			// own Escape handling, but since we pass `:scrim="false"` and
			// `touchless`, none of the dismiss paths fire. Only fires for
			// temporary drawers — persistent (isFixed) drawers like the
			// job view's Stream/Files panel are part of the page layout
			// and shouldn't close on Escape.
			handleEscapeKey(event) {
				if (event.key === 'Escape' && this.openState && !this.isFixed) {
					this.$store.dispatch('VUEX_UI_HIDE_RIGHT_DRAWER')
				}
			},

			// Close the drawer when clicking outside it. We disabled the
			// scrim (so the page behind stays interactive), which also
			// killed Vuetify's click-outside handler — so we wire our own.
			// Only applies to temporary drawers (Absences row-click panel
			// etc.); persistent drawers (job view Stream/Files panel)
			// should stay open as users tab through Overview/Details/etc.
			// Ignore clicks on the drawer itself and on elements marked
			// `data-drawer-keep-open` (rows that swap drawer content).
			handleOutsideClick(event) {
				if (!this.openState) return
				if (this.isFixed) return
				const drawer = this.$refs.rightDrawerContainer?.$el
				if (!drawer) return
				if (drawer.contains(event.target)) return
				if (event.target.closest('[data-drawer-keep-open]')) return
				this.$store.dispatch('VUEX_UI_HIDE_RIGHT_DRAWER')
			},

			handleMouseEnter() {
				this.mouseIsOverDrawer = true
				this.$nextTick(this.handleOverlayVisibility())
			},

			handleMouseLeave() {
				this.mouseIsOverDrawer = false
				this.$nextTick(this.handleOverlayVisibility())
			},

			handleOverlayVisibility () {
				if (this.openState) {
					this.overlayOpenState = this.mouseIsOverDrawer
				}
			},

			initEvents() {
				let me = this
				let el = this.$refs['rightDrawerContainer'].$el
				if (this.isFixed === false) {	
					el.addEventListener('mouseenter', me.handleMouseEnter)
					el.addEventListener('mouseleave', me.handleMouseLeave)
				} else {
					el.removeEventListener('mouseenter', me.handleMouseEnter)
					el.removeEventListener('mouseleave', me.handleMouseLeave)
				}
			}
		},

		watch: {
			'content': {
				deep: true,
				handler() {
                    this.loadContent()
				}
			},
			
			'openState': {
				handler(oldVal, newVal) {
					this.$nextTick(this.handleOverlayVisibility)
				}
			}
		}
	}
</script>